import { motion } from "framer-motion";

export default function DossierStamp({ title, sub, rotate = -8, className = "", testid }) {
  return (
    <motion.div
      data-testid={testid}
      className={`inline-block ${className}`}
      initial={{ scale: 2.3, opacity: 0, rotate: rotate * 2.5 }}
      whileInView={{ scale: 1, opacity: 1, rotate }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.55, ease: [0.34, 1.56, 0.64, 1] }}
    >
      <div className="border-[3px] border-oxblood p-1.5 opacity-90">
        <div className="border border-oxblood px-6 py-3 text-center">
          <p className="font-sans text-[10px] tracking-[0.35em] text-oxblood">{sub}</p>
          <p className="mt-1 font-sans text-lg font-semibold tracking-[0.2em] text-oxblood md:text-xl">
            {title}
          </p>
        </div>
      </div>
    </motion.div>
  );
}
